import { BaseStore } from "stores/base_store";
import { makeAutoObservable, runInAction } from "mobx"
import CreditLogAPI from "api/credit_log_api";
import { api_get } from "api/utils";
import { api_post } from "api/utils";
import { PagedResult } from "utils/types";

export type CreditLogProps = {
    uuid: string;
    user: string;
    credit: string;
    acct_credit: number;
    acct_debit: number;
    source: string;
    source_id: string;
    associated_type: string;
    associated_uuid: string;
    notes: string;

    date_created: string;
    date_updated: string;
    updateProps?: (attributes: CreditLogProps) => void;
};

// Domain object CreditLog
export class CreditLog implements CreditLogProps {
    uuid = "";
    user = "";
    credit = "";
    acct_credit = 0;
    acct_debit = 0;
    source = "";
    source_id = "";
    associated_type = "";
    associated_uuid = "";
    notes = "";

    date_created = "";
    date_updated = "";

    constructor(attributes: CreditLogProps) {
        makeAutoObservable(this, {
            updateProps: false
        })
        if (attributes) {
            this.updateProps(attributes);
        }
    }

    updateProps(attributes: CreditLogProps) {
		runInAction(() => {
			Object.assign(this, attributes);
		})

    }

}


export class CreditLogStore extends BaseStore<CreditLogProps, CreditLog> {

    async fetchCreditLog(cursor = "") {
        return CreditLogAPI.list(cursor).then((resp) => {
            this.receiveUpdate(resp.items);
            if (resp.cursor) {
                this.fetchCreditLog(resp.cursor);
            }
            // This returns as possibly incomplete list due to the cursor,
            // but CreditLogStore.items is complete when .then() is called
            // so you can/should just use that.
            return resp.items;
        })
    }

    async fetchCreditLogViaSupport(support_identity: string, user_uuid: string, cursor = ""): Promise<PagedResult<CreditLogProps>> {
        return api_get(`/credit/log-via-support?identity=${support_identity}&user_uuid=${user_uuid}&cursor=${cursor}`).then((resp) => {
            return resp.json();
        });
    }

    async doEditCredit(credit_uuid: string,
        to_minutes: number,
        source: string,
        source_id: string,
        notes: string) {
        return api_post("/credit/log-via-support", {
            credit_uuid, to_minutes, source, source_id, notes
        }).then((resp) => {
            return resp.json();
        });
    }

    modelConstructor() {
        return CreditLog;
    }

}
